'use strict';

exports['default'] = {
  hasDOM: function hasDOM() {
    return typeof document !== 'undefined';
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/environment.js
// module id = 1481
// module chunks = 0